<template>
  <div class="page formal-page">
    <div class="card formal-head"><div class="section-kicker">SIGNED CONTRACTS · PDF</div><h1>我的电子协议（PDF）</h1><p>这里只展示当前有效绑定设备的正式签约协议。</p></div>
    <div class="card list">
      <div v-if="!rows.length" class="empty">当前没有有效签约协议</div>
      <div class="item" v-for="x in rows" :key="x.id"><div><b>{{x.agreement_title}}</b><span>{{x.unique_code}} · {{x.machine_code}} · {{x.signed_at}}</span></div><button class="btn" @click="openPdf(x.id)">查看/下载PDF</button></div>
    </div>
  </div>
</template>
<script>
import { api } from '../api'
export default {
  data:()=>({rows:[]}),
  async created(){this.rows=(await api.get('/h5/agreements')).data.data||[]},
  methods:{
    async openPdf(id){
      const token=localStorage.getItem('authToken')||''
      const base=api.defaults.baseURL||''
      const downloadUrl=base+'/h5/agreement/pdf/public?id='+encodeURIComponent(id)+'&token='+encodeURIComponent(token)
      try{
        const response=await api.get('/h5/agreement/pdf',{params:{id},responseType:'blob'})
        if (await response.data.slice(0,5).text() !== '%PDF-') {
          let message='服务器未返回有效PDF，请稍后重试'
          try { message=JSON.parse(await response.data.text()).message || message } catch(ignore) {}
          throw new Error(message)
        }
        // Mobile viewers need an HTTPS URL, not a browser-local blob URL.
        if (/Android|iPhone|iPad|MicroMessenger/i.test(navigator.userAgent)) {
          window.location.href=downloadUrl
          return
        }
        const blob=new Blob([response.data],{type:'application/pdf'})
        const blobUrl=URL.createObjectURL(blob)
        const a=document.createElement('a')
        a.href=blobUrl
        a.download='正式电子协议-'+id+'.pdf'
        document.body.appendChild(a)
        a.click()
        a.remove()
        setTimeout(()=>URL.revokeObjectURL(blobUrl),60000)
      }catch(e){
        let message=e.message || 'PDF下载失败，请稍后重试'
        if(e.response&&e.response.data instanceof Blob){
          try{const text=await e.response.data.text();const data=JSON.parse(text);message=data.message||message}catch(ignore){}
        }
        alert(message)
      }
    }
  }
}
</script>
<style scoped>
.formal-head{background:linear-gradient(135deg,#123d30,#16b873);color:#fff}.formal-head p{color:rgba(255,255,255,.82)}.list{margin-top:16px}.item{display:flex;align-items:center;justify-content:space-between;gap:14px;padding:17px 0;border-bottom:1px solid #edf3ef}.item b,.item span{display:block}.item span{font-size:12px;color:#87948e;margin-top:5px}.empty{padding:30px 0;color:#87948e}@media(max-width:600px){.item{display:block}.item .btn{width:100%;margin-top:12px}}
</style>
